var _g, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1936_132438)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -6,
    y: -5,
    width: 50,
    height: 50,
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M20 21.7267C15.9636 21.7267 12.6914 18.4545 12.6914 14.418C12.6914 10.3816 15.9636 7.10938 20 7.10938C24.0365 7.10938 27.3087 10.3816 27.3087 14.418C27.3087 18.4545 24.0365 21.7267 20 21.7267Z",
    fill: "#B0B7C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.55685 38.533C4.26507 29.8125 11.3429 25.3789 19.9697 25.3789C28.7179 25.3789 35.9053 29.5689 36.4407 38.5345C36.4621 38.8916 36.4407 39.9962 35.0682 39.9962C28.2975 39.9962 18.2364 39.9962 4.88493 39.9962C4.42669 39.9962 3.51828 39.008 3.55685 38.533Z",
    fill: "#B0B7C3"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M7.99989 23.1111C6.03621 23.1111 4.44434 21.5192 4.44434 19.5556C4.44434 17.5919 6.03621 16 7.99989 16C9.96357 16 11.5554 17.5919 11.5554 19.5556C11.5554 21.5192 9.96357 23.1111 7.99989 23.1111Z",
    fill: "#B0B7C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.000579275 31.2899C0.345119 27.0475 3.78837 24.8906 7.98519 24.8906C12.2411 24.8906 15.7377 26.929 15.9981 31.2906C16.0085 31.4644 15.9981 32.0017 15.3304 32.0017C12.0366 32.0017 7.14198 32.0017 0.646669 32.0017C0.423744 32.0017 -0.0181882 31.521 0.000579275 31.2899Z",
    fill: "#B0B7C3"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M31.9999 23.1111C30.0362 23.1111 28.4443 21.5192 28.4443 19.5556C28.4443 17.5919 30.0362 16 31.9999 16C33.9636 16 35.5554 17.5919 35.5554 19.5556C35.5554 21.5192 33.9636 23.1111 31.9999 23.1111Z",
    fill: "#B0B7C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0006 31.2899C24.3451 27.0475 27.7884 24.8906 31.9852 24.8906C36.2411 24.8906 39.7377 26.929 39.9981 31.2906C40.0085 31.4644 39.9981 32.0017 39.3304 32.0017C36.0366 32.0017 31.142 32.0017 24.6467 32.0017C24.4237 32.0017 23.9818 31.521 24.0006 31.2899Z",
    fill: "#B0B7C3"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 38,
    height: 38,
    rx: 19,
    stroke: "white",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1936_132438"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group.9342d00893f8fb3053865a12d1817ec8.svg";
export { ForwardRef as ReactComponent };